import { AuthingModal } from "@/components/AuthingModal";
import { FieldConfig, SimpleForm } from "@/components/SimpleForm";
import React, { useEffect, useRef } from "react";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { FormInstance } from "antd/es/form";
import { User } from "authing-js-sdk";
import moment from "moment";

export interface MediaEditFormProps {
  isModalVisible: boolean;
  renderFieldConfig: FieldConfig[];
  user: User;
  handleOkCb?: Function;
  handleCancelCb?: Function;
}

export const MediaEditForm: FC<MediaEditFormProps> = ({
  user,
  isModalVisible,
  handleOkCb,
  handleCancelCb,
  renderFieldConfig,
}) => {
  const { t } = useTranslation();

  const handleOk = () => {
    handleOkCb?.(formRef.current?.getFieldsValue());
  };

  const handleCancel = () => {
    handleCancelCb?.();
  };

  const formRef = useRef<FormInstance>(null);

  useEffect(() => {
    if (renderFieldConfig.length > 0) {
      const toSet: any = {};
      if (renderFieldConfig[0].type === "datetime") {
        toSet[renderFieldConfig[0]["name"] as string] =
          renderFieldConfig[0].value && moment(renderFieldConfig[0].value);
      } else {
        toSet[renderFieldConfig[0]["name"] as string] =
          renderFieldConfig[0].value;
      }
      formRef.current?.setFieldsValue(toSet);
    }
  }, [renderFieldConfig, user]);
  return (
    <AuthingModal
      title={t("user.personalAuthentication")}
      visible={isModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      okText={t("common.submit")}
      cancelText={t("common.cancel")}
    >
      <SimpleForm
        ref={formRef}
        labelAlign="left"
        layout="vertical"
        labelCol={{ span: 24 }}
        useRowLayout={true}
        rowProps={{
          gutter: 36,
        }}
        fieldConfig={renderFieldConfig}
      />
    </AuthingModal>
  );
};
